import { render, staticRenderFns } from "./LeLoading.vue?vue&type=template&id=0c5b7369&scoped=true"
var script = {}
import style0 from "./LeLoading.vue?vue&type=style&index=0&id=0c5b7369&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b7369",
  null
  
)

export default component.exports